import React from 'react';
import { Clock } from 'lucide-react';
import '../ui/hint.css';

const URL_RE = /(https?:\/\/[^\s)»]+)/g;

// Transforme les adresses d'une étape en liens cliquables (nouvel onglet).
export const Linkify = ({ text }) => (
  <>{String(text || '').split(URL_RE).map((part, i) => (/^https?:\/\//.test(part) ? <a key={i} href={part} target="_blank" rel="noreferrer">{part.replace(/^https?:\/\//, '')}</a> : <React.Fragment key={i}>{part}</React.Fragment>))}</>
);

// Pas à pas numéroté partagé par toutes les fenêtres de branchement (caisse, canaux, Google).
export const SetupSteps = ({ steps, title = 'Pas à pas', minutes, done = 0, testId = 'setup-steps' }) => {
  if (!steps?.length) return null;
  return (
    <div data-testid={testId}>
      <div className="ui-steps-head">
        <p>{title} · {steps.length} étape{steps.length > 1 ? 's' : ''}</p>
        {minutes ? <small data-testid={`${testId}-minutes`}><Clock size={10} className="inline mr-1 -mt-0.5" aria-hidden />~{minutes} min</small> : null}
      </div>
      <ol className="ui-steps">
        {steps.map((s, i) => <li key={i} className={i < done ? 'is-done' : ''} data-testid={`${testId}-${i + 1}`}><i>{i + 1}</i><span><Linkify text={s} /></span></li>)}
      </ol>
    </div>
  );
};

export default SetupSteps;
